import React from 'react'
import {Card, CardHeader, Col, Nav, NavItem, NavLink,} from "reactstrap";
import Row from "reactstrap/es/Row";
// Strings
import Chart from "chart.js";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import {report_strings} from "../../translations/report_translations";
import ErrorModal from "../Alerts/ErrorModal";
import {student_strings} from "../../translations/student_translations";
import reportApiService from "../../api/report-api-service";
import CardBody from "reactstrap/es/CardBody";
import {Bar, Line} from "react-chartjs-2";
import {chartExample1, chartExample2, chartOptions, parseOptions} from "variables/charts.js";
import classnames from "classnames";
import CardTitle from "reactstrap/es/CardTitle";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);
let studentStrings = new LocalizedStrings(student_strings);

const propTypes = {};

export default class NewUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chartData: null,
            totalChartData: null,
            eventsChartData: null,
            activityChartData: null,
            dailyVisitsData: null,
            activeNav: 1,
            isLoading: false,
        };
    }

    componentDidMount() {
        this.getData()

        if (window.Chart) {
            parseOptions(Chart, chartOptions());
        }
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    render() {
        this.localize();

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.showError &&
                    <ErrorModal showError={this.state.showError} error={this.state.error}
                                toggleErrorModal={() => this.toggleErrorModal()}/>
                    }

                    <Row>
                        <Col lg="12">
                            {this.renderReport()}
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <Col lg="6">
                            {this.renderTotalUsers()}
                        </Col>
                        <Col lg="6">
                            {this.renderEvents()}
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <Col lg="12">
                            {this.renderActivityReport()}
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <Col lg="12">
                            {this.renderDailyVisits()}
                        </Col>
                    </Row>
                </>
            </LoadingOverlay>
        )
    }

    toggleNavs = (e, index) => {
        e.preventDefault();
        this.setState({
            activeNav: index
        });

        this.getData(index === 1 ? "week" : index === 2 ? "month" : "3m")
    };

    renderReport() {
        if (this.state.chartData !== null) {
            return <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                    {this.state.attendance_loading &&
                    <RotateCircleLoading color="white"/>
                    }
                    <CardTitle>New Users and Clients</CardTitle>
                    <Row className="align-items-center">
                        <div className="col">
                            <Nav className="justify-content-end" pills>
                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 1
                                        })}
                                        data-toggle="tab"
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 1)}
                                    >
                                        <span className="d-none d-md-block">{commonStrings.week}</span>
                                        <span
                                            className="d-md-none">{commonStrings.week.charAt(0)}</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 2
                                        })}
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 2)
                                        }
                                    >
                                        <span className="d-none d-md-block">{commonStrings.month}</span>
                                        <span
                                            className="d-md-none">{commonStrings.month.charAt(0)}</span>
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 3
                                        })}
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 3)
                                        }
                                    >
                                        <span className="d-none d-md-block">6 months</span>
                                        <span
                                            className="d-md-none">3m</span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                    </Row>
                </CardHeader>
                <CardBody>
                    {/* Chart */}
                    <div className="chart">
                        <Bar
                            data={this.state.chartData}
                            options={chartExample1.options}
                            getDatasetAtEvent={e => console.log(e)}
                        />
                    </div>
                </CardBody>
            </Card>
        }
    }

    renderTotalUsers() {
        if (this.state.totalChartData !== null) {
            return <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                    {this.state.attendance_loading &&
                    <RotateCircleLoading color="white"/>
                    }
                    <CardTitle>Total users</CardTitle>
                    <Row className="align-items-center">
                        <div className="col">
                            <Nav className="justify-content-end" pills>
                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 1
                                        })}
                                        data-toggle="tab"
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 1)}
                                    >
                                        <span className="d-none d-md-block">{commonStrings.week}</span>
                                        <span
                                            className="d-md-none">{commonStrings.week.charAt(0)}</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 2
                                        })}
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 2)
                                        }
                                    >
                                        <span className="d-none d-md-block">{commonStrings.month}</span>
                                        <span
                                            className="d-md-none">{commonStrings.month.charAt(0)}</span>
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 3
                                        })}
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 3)
                                        }
                                    >
                                        <span className="d-none d-md-block">6 months</span>
                                        <span
                                            className="d-md-none">3m</span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                    </Row>
                </CardHeader>
                <CardBody>
                    {/* Chart */}
                    <div className="chart">
                        <Line
                            data={this.state.totalChartData}
                            options={chartExample2.options}
                            getDatasetAtEvent={e => console.log(e)}
                        />
                    </div>
                </CardBody>
            </Card>
        }
    }

    renderEvents() {
        if (this.state.eventsChartData !== null) {
            return <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                    {this.state.attendance_loading &&
                    <RotateCircleLoading color="white"/>
                    }
                    <CardTitle>Events</CardTitle>
                    <Row className="align-items-center">
                        <div className="col">
                            <Nav className="justify-content-end" pills>
                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 1
                                        })}
                                        data-toggle="tab"
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 1)}
                                    >
                                        <span className="d-none d-md-block">{commonStrings.week}</span>
                                        <span
                                            className="d-md-none">{commonStrings.week.charAt(0)}</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 2
                                        })}
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 2)
                                        }
                                    >
                                        <span className="d-none d-md-block">{commonStrings.month}</span>
                                        <span
                                            className="d-md-none">{commonStrings.month.charAt(0)}</span>
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 3
                                        })}
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 3)
                                        }
                                    >
                                        <span className="d-none d-md-block">6 months</span>
                                        <span
                                            className="d-md-none">3m</span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                    </Row>
                </CardHeader>
                <CardBody>
                    {/* Chart */}
                    <div className="chart">
                        <Line
                            data={this.state.eventsChartData}
                            options={chartExample2.options}
                            getDatasetAtEvent={e => console.log(e)}
                        />
                    </div>
                </CardBody>
            </Card>
        }
    }

    renderActivityReport() {
        if (this.state.activityChartData !== null) {
            return <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                    {this.state.attendance_loading &&
                    <RotateCircleLoading color="white"/>
                    }
                    <CardTitle>Classes, Tickets, Students</CardTitle>
                    <Row className="align-items-center">
                        <div className="col">
                            <Nav className="justify-content-end" pills>
                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 1
                                        })}
                                        data-toggle="tab"
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 1)}
                                    >
                                        <span className="d-none d-md-block">{commonStrings.week}</span>
                                        <span
                                            className="d-md-none">{commonStrings.week.charAt(0)}</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 2
                                        })}
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 2)
                                        }
                                    >
                                        <span className="d-none d-md-block">{commonStrings.month}</span>
                                        <span
                                            className="d-md-none">{commonStrings.month.charAt(0)}</span>
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 3
                                        })}
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 3)
                                        }
                                    >
                                        <span className="d-none d-md-block">6 months</span>
                                        <span
                                            className="d-md-none">3m</span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                    </Row>
                </CardHeader>
                <CardBody>
                    {/* Chart */}
                    <div className="chart">
                        <Line
                            data={this.state.activityChartData}
                            options={chartExample2.options}
                            getDatasetAtEvent={e => console.log(e)}
                        />
                    </div>
                </CardBody>
            </Card>
        }
    }

    renderDailyVisits() {
        if (this.state.dailyVisitsData !== null) {
            return <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                    {this.state.attendance_loading &&
                    <RotateCircleLoading color="white"/>
                    }
                    <CardTitle>Daily Visits</CardTitle>
                    <Row className="align-items-center">
                        <div className="col">
                            <Nav className="justify-content-end" pills>
                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 1
                                        })}
                                        data-toggle="tab"
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 1)}
                                    >
                                        <span className="d-none d-md-block">{commonStrings.week}</span>
                                        <span
                                            className="d-md-none">{commonStrings.week.charAt(0)}</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 2
                                        })}
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 2)
                                        }
                                    >
                                        <span className="d-none d-md-block">{commonStrings.month}</span>
                                        <span
                                            className="d-md-none">{commonStrings.month.charAt(0)}</span>
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        className={classnames("py-2 px-3", {
                                            active: this.state.activeNav === 3
                                        })}
                                        href="#pablo"
                                        onClick={e => this.toggleNavs(e, 3)
                                        }
                                    >
                                        <span className="d-none d-md-block">6 months</span>
                                        <span
                                            className="d-md-none">3m</span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </div>
                    </Row>
                </CardHeader>
                <CardBody>
                    {/* Chart */}
                    <div className="chart">
                        <Line
                            data={this.state.dailyVisitsData}
                            options={chartExample2.options}
                            getDatasetAtEvent={e => console.log(e)}
                        />
                    </div>
                </CardBody>
            </Card>
        }
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    getData(type = "week") {
        this.setState({isLoading: true});

        reportApiService.analytics(type)
            .then(res => {
                this.setState({
                    isLoading: false,
                    chartData: res[0].data || [],
                    totalChartData: res[1].data || [],
                    eventsChartData: res[2].data || [],
                    activityChartData: res[3].data || [],
                    dailyVisitsData: res[4].data || [],
                });

            })
            .catch((e) => {
                this.handleNetworkError(e)
            });

        // reportApiService.admin_new_users(type)
        //     .then(res => {
        //         this.setState({
        //             isLoading: false,
        //             chartData: res.data,
        //         });
        //     })
        //     .catch((e) => {
        //         this.handleNetworkError(e)
        //     });
        //
        // reportApiService.admin_total_users(type)
        //     .then(res => {
        //         this.setState({
        //             isLoading: false,
        //             totalChartData: res.data,
        //         });
        //     })
        //     .catch((e) => {
        //         this.handleNetworkError(e)
        //     });
        //
        // reportApiService.admin_events(type)
        //     .then(res => {
        //         this.setState({
        //             isLoading: false,
        //             eventsChartData: res.data,
        //         });
        //     })
        //     .catch((e) => {
        //         this.handleNetworkError(e)
        //     });
        //
        // reportApiService.admin_activity(type)
        //     .then(res => {
        //         this.setState({
        //             isLoading: false,
        //             activityChartData: res.data,
        //         });
        //     })
        //     .catch((e) => {
        //         this.handleNetworkError(e)
        //     });
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    toggleUserModal = state => {
        this.setState({
            showUserModal: !this.state.showUserModal
        });
    };

}

NewUsers.propTypes = propTypes;